import { render, staticRenderFns } from "./TeacherEdu.vue?vue&type=template&id=2d53dcfd&scoped=true&"
import script from "./TeacherEdu.vue?vue&type=script&lang=js&"
export * from "./TeacherEdu.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEdu.vue?vue&type=style&index=0&id=2d53dcfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d53dcfd",
  null
  
)

export default component.exports